import { render } from "./Booking_Itinerary.vue?vue&type=template&id=d488f57a&scoped=true"
import script from "./Booking_Itinerary.vue?vue&type=script&lang=js"
export * from "./Booking_Itinerary.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d488f57a"

export default script